module.exports = __webpack_public_path__ + "static/media/realtor-2.5a00628d.jpeg";